<template>
  <v-container -max-width-limited>
    <v-skeleton-loader
            v-if="!order"
            type="image"
    ></v-skeleton-loader>
    <v-overlay v-if="loading" contained>
      <v-progress-circular indeterminate color="primary" model-value="20" :size="42"></v-progress-circular>
    </v-overlay>
    <v-card v-if="order" class="mt-5 mb-5" :color="'#eee'">
      <v-container>
          <v-alert
                  v-if="order.type == 'archive'"
                  type="warning"
                  dismissible
          >{{$t('order.type.archive.message')}}</v-alert>
        <div class="col-md-12 clearfix order-information">
          <div class="entry-edit-head">
            <h2 class="icon-head head-account">
              {{ $t('Order') }} <span v-if="order.externalOrderId">#{{ order.externalOrderId }}</span>
            </h2>
          </div>
          <v-row>
            <v-col>
              <!--Order Information-->
              <div class="entry-edit">
                <div class="entry-edit-head">
                  <h4 class="icon-head head-account">{{ $t('Order information') }}</h4>
                </div>
                <div class="fieldset">
                  <table>
                    <caption></caption>
                    <thead>
                    <tr>
                      <th id="default"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="order.orderDate">
                      <td>
                        <label>{{ $t('Order date') }}: </label>
                      </td>
                      <td class="value">
                        <strong>{{ formatDate(order.orderDate) }}</strong>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label>{{ $t('Order status') }}: </label>
                      </td>
                      <td class="value">
                        <strong><span
                            id="order_status">{{ $t('order.status.' + order.orderState) }}</span></strong>
                      </td>
                    </tr>
                    <tr v-if="order.shopOrderSystem">
                      <td>
                        <label>{{ $t('Ordered in') }} </label>
                      </td>
                      <td class="value">
                        <strong v-if="order.shopOrderSystemName">
                          {{ order.shopOrderSystemName }}
                        </strong>
                        <strong v-else>
                          {{ $t('channel.code.' + order.shopOrderSystem) }}
                        </strong>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </v-col>
            <v-col>
              <!--Account Information-->
              <div class="entry-edit">
                <v-alert
                    v-if="order.postmarkHistory?.bounceError"
                    type="warning"
                >{{$t('order.message.email_bounce')}}</v-alert>
                <div class="entry-edit-head">
                  <h4 class="icon-head head-account">{{ $t('User Account Information') }}</h4>
                </div>
                <div class="fieldset">
                  <div class="hor-scroll">
                    <table class="form-list" v-if="order">
                      <caption></caption>
                      <thead>
                      <tr>
                        <th id="default"></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td>
                          <label>{{ $t('E-Mail') }}: </label>
                        </td>
                        <td class="value">
                          <div v-if="order.userCommunicationEmail && order.userEmail !== order.userCommunicationEmail">
                            <s>{{ order.userEmail}}</s>
                            <strong>{{ order.userCommunicationEmail }}</strong>
                          </div>
                          <div v-else>
                            <strong>{{ order.userEmail }}</strong>
                          </div>
                        </td>
                      </tr>
                      <tr v-if="order.billingAddress.ustId">
                        <td><label>{{ $t('Tax/VAT Number') }}: </label></td>
                        <td class="value">
                          <strong>{{ order.billingAddress.ustId }}</strong>
                        </td>
                      </tr>
                      <tr v-if="order.customer && order.customer.hasAccount != null">
                        <td><label>{{ $t('Account') }}: </label></td>
                        <td class="value">
                          <strong>{{ order.customer.hasAccount ? $t('Yes'): $t('No') }}</strong>
                        </td>
                      </tr>
                      <tr v-if="order.customer && order.customer.customerGroup">
                        <td>
                          <label>{{ $t('Customer group') }}: </label>
                        </td>
                        <td class="value">
                          <strong>{{ order.customer.customerGroup }}</strong>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="col-md-12 clearfix adresses">
          <v-row>
            <v-col v-if="order.billingAddress">
              <!--Billing Address-->
              <div class="entry-edit-head">
                <h4 class="icon-head head-billing-address">{{ $t('Billing address') }}</h4>
              </div>
              <fieldset>
                <legend></legend>
                <address style="background-color:#fff">
                  {{ order.billingAddress.firstname }} {{ order.billingAddress.lastname }}<br>
                  {{ order.billingAddress.street1 }} {{ order.billingAddress.street2 }}<br>
                  {{ order.billingAddress.postalCode }} {{ order.billingAddress.city }}<br>
                  <span v-if="order.billingAddress.telephone">{{ order.billingAddress.telephone }}<br></span>
                  <span v-if="order.billingAddress.companyName">{{ order.billingAddress.companyName }}<br></span>
                  <span v-if="order.billingAddress.ustId">{{ order.billingAddress.ustId }}<br></span>
                  {{ $t('main.country.' + order.billingAddress.country.toLowerCase()) }}<br>
                </address>
              </fieldset>
            </v-col>
            <v-col v-if="order.shippingAddress">
              <!--Shipping Address-->
              <div class="entry-edit">
                <div class="entry-edit-head">
                  <h4 class="icon-head head-shipping-address">{{ $t('Shipping address') }}</h4>
                  <fieldset>
                    <legend></legend>
                    <address style="background-color:#fff">
                      {{ order.shippingAddress.firstname }} {{ order.shippingAddress.lastname }}<br>
                      {{ order.shippingAddress.street1 }} {{ order.shippingAddress.street2 }}<br>
                      {{ order.shippingAddress.postalCode }} {{ order.shippingAddress.city }}<br>
                      <span v-if="order.shippingAddress.telephone">{{ order.shippingAddress.telephone }}<br></span>
                      <span v-if="order.shippingAddress.companyName">{{ order.shippingAddress.companyName }}<br></span>
                      <span v-if="order.shippingAddress.ustId">{{ order.shippingAddress.ustId }}<br></span>
                      {{ $t('main.country.' + order.shippingAddress.country.toLowerCase()) }}<br>
                    </address>
                  </fieldset>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
        <v-row>
          <v-col>
            <div class="col-md-12 clearfix shipping-infos" v-if="order.shipments">
              <h4 class="icon-head head-billing-address">{{ $t('Shipping Infos') }}</h4>
              <div v-for="(shipment, index) in order.shipments" :key="index" class="mb-2 pb-2" :class="{ 'border-bottom': index < order.shipments.length - 1 }">
                <b>
                  <template v-if="order.shipments.length > 1">
                    #{{ index+1 }}
                  </template>
                  <span v-if="shipment.method">
                    {{ mapTranslations(order.shipment.translations, $t('order.shipping.method.' + shipment.method)) }}
                  </span>
                </b>
                <br/>
                <span v-if="shipment.state">{{ $t('Status:') }} {{ $t('order.shipping.status.' + shipment.state) }}</span>
                <span v-if="shipment.details && shipment.details.warehouseName">
                  ({{ shipment.details.warehouseName }})
                </span>
                <template v-if="shipment.trackingUrl">
                  <div v-for="(url, index) in shipment.trackingUrl.split('<br/>')" :key="index">
                    <a v-if="!shipment.isCollect" target="_blank" :href="url">{{ url }}</a>
                  </div>
                </template>
                <div v-if="shipment.items && shipment.items.length > 0" class="pa-2">
                  <v-data-table
                    size="small"
                    density="compact"
                    :headers="[
                            {text: $t('Articlenumber'), value: 'code', sortable: false},
                          {text: $t('Quantity'), value: 'quantity', sortable: false},
                    ]"
                    :items="shipment.items"
                    :hide-default-footer="true"
                    class="elevation-1"
                  >
                  </v-data-table>
                </div>
              </div>
            </div>
            <div class="col-md-12 clearfix shipping-infos" v-else>
              {{ $t('No shipping information available') }}
            </div>
          </v-col>
          <v-col>
            <div class="col-md-12 clearfix actions"
                 v-if="showActions">
              <div class="entry-edit-head">
                <h4>
                  {{ $t('Actions') }}
                </h4>
              </div>
              <v-row>
                <v-col v-if="!order.postmarkHistory || !order.postmarkHistory.bounceError">
                  <v-btn
                    @click="sendOrderConfirmation(order.externalOrderId, order.localeCode)"
                    class="mt-2"
                  >
                    <v-icon>mdi-send</v-icon>
                    {{ $t('order.buttons.confirmation_send.label') }}
                  </v-btn>
                  <div v-for="(shipment, index) in order.shipments" :key="index">
                    <v-btn
                      v-if="shipment.state === 'shipped' && shipment.id"
                      @click="sendShipmentConfirmation(order.externalOrderId, shipment.id, order.localeCode)"
                      class="mt-2"
                    >
                      <v-icon>mdi-send</v-icon>
                      <template v-if="order.shipments.length > 1">
                        #{{ index+1 }}
                      </template>
                      {{ $t('order.buttons.shipment_send.label') }}
                    </v-btn>
                  </div>
                  <v-btn
                    v-if="order.invoicePdf"
                    @click="sendInvoicePdf(order.externalOrderId, order.invoicePdf, order.localeCode)"
                    class="mt-2"
                  >
                    <v-icon>mdi-send</v-icon>
                    {{ $t('order.buttons.invoice_send.label') }}
                  </v-btn>
                </v-col>
                <v-col>
                  <a
                    v-if="order.invoicePdf"
                    class="mt-2 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                    :download="$t('order.label.invoice') +'_'+order.externalOrderId+'.pdf'"
                    :href="'data:application/octet-stream;base64,'+order.invoicePdf">
                    <v-icon>mdi-download</v-icon>
                    {{ $t('order.buttons.invoice_download.label') }}
                  </a>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
        <div class="col-md-12 clearfix order-totals">
          <v-row>
            <v-col v-if="order.total > 0 || order.orderTotalPaid > 0">
              <h4>{{ $t('Order totals') }}</h4>
              <table>
                <caption></caption>
                <thead>
                <tr>
                  <th id="default"></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>{{ $t('Subtotal') }}:</td>
                  <td><span class="price">{{ formatMoney(order.itemsTotalGrossWithoutDiscount) }}</span></td>
                </tr>
                <tr>
                  <td>{{ $t('Shipping costs') }}:</td>
                  <td><span class="price">{{ formatMoney(order.shippingGrossWithDiscount) }}</span></td>
                </tr>
                <tr v-if="order.discountTotalOnGross">
                  <td>{{ $t('Discount Total') }}:</td>
                  <td>
                    <span class="price">
                      <template v-if="order.discountTotalOnGross > 0">-</template>{{ formatMoney(order.discountTotalOnGross) }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t('Value added tax') }}:</td>
                  <td><span class="price">{{ formatMoney(order.orderTotalTaxWithDiscount) }}</span></td>
                </tr>
                <tr>
                  <td>{{ $t('Total') }}:</td>
                  <td><span class="price">{{ formatMoney(order.orderTotalPaid) }}</span></td>
                </tr>
                <tr>
                  <td>{{ $t('Currency') }}:</td>
                  <td>{{ order.currency }}</td>
                </tr>
                </tbody>
              </table>
            </v-col>
            <v-col v-if="order.statusHistory">
              <h4>{{ $t('Information on order status') }}</h4>
              <ul class="note-list">
                <li v-for="(status,index) in order.statusHistory" :key="index">
                  <strong>{{ formatDate(status.createdAt) }}</strong>
                  <span class="separator"> | {{ status.status }}</span><br>
                  <small>{{ status.message }}</small><br>
                </li>
              </ul>
            </v-col>
          </v-row>
        </div>
        <div class="col-md-12 clearfix order-items" v-if="items.length > 0">
          <h4>{{ $t('Ordered articles') }}</h4>
          <v-data-table
              :headers="headers"
              :items="items"
              :hide-default-footer="true"
              class="elevation-1"
          >
          </v-data-table>
        </div>
        <div class="col-md-12 clearfix payment-method" v-if="order.payment">
          <h4>{{ $t('Transaction Infos') }}</h4>
          {{ $t('Payment') }}:
          <span v-if="order.payment.method">{{ $t('order.payment.method.' + order.payment.method) }}</span>&nbsp;
          <span v-if="order.payment.state">({{ $t('order.payment.status.' + order.payment.state) }})</span>
        </div>
        <div class="col-md-12 clearfix payment-method" v-if="order.paymentType">
          <h4>{{ $t('Transaction Infos') }}</h4>
          {{ $t('Payment') }}:
          <div>
            {{ $t('order.payment.method.' + order.paymentType) }}
          </div>
        </div>
        <div class="col-md-12 clearfix cic-support">
          <forward-to-support
              :type="'order'"
              :subject="order.number"
              :additional_information="additionalInformations"
          />
        </div>
      </v-container>
    </v-card>
    <v-btn
        @click="$router.back()"
        class="back-btn"
    >
      <v-icon>mdi-arrow-left</v-icon>
      {{ $t('Back') }}
    </v-btn>
    <v-snackbar
        v-model="snackbar"
        vertical
        right
        :color="messageType"
        :location="'top'"
    >
      <div class="text-subtitle-1 pb-2">{{ $t(message) }}</div>
      <template v-slot:action="{ attrs }">
        <v-btn
            color="black"
            text
            v-bind="attrs"
            @click="snackbar = false"
        >
          {{ $t('Close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import {OrderService} from "@/services/OrderService";
import {formatDate, formatMoney} from "@/services/globalFunctions";
import ForwardToSupport from "@/components/base/ForwardToSupport";

export default {
  name: "OrderDetail",
  components: {
    ForwardToSupport
  },
  data() {
    return {
      loading: false,
      headers: [],
      order: null,
      user: null,
      items: [],
      message: '',
      messageType: '',
      snackbar: false,
      additionalInformations: {},
      orderStatesForAction: ['synced', 'processing', 'fulfilled', 'service_fulfilled'],
    }
  },
  mounted() {
    this.headers = [
      {text: this.$i18n.t('Productdescription'), value: 'description', sortable: false},
      {text: this.$i18n.t('Articlenumber'), value: 'itemNo', sortable: false},
      {text: this.$i18n.t('Product Unit Price'), value: 'unitGrossWithoutDiscount', sortable: false},
      {text: this.$i18n.t('Quantity'), value: 'quantity', sortable: false},
        {text: this.$i18n.t('Product Line Price'), value: 'lineGrossWithoutDiscount', sortable: false},
        {text: this.$i18n.t('Product Line Discount'), value: 'lineDiscountOnGross', sortable: false},
        {text: this.$i18n.t('Product Line Price With Discount'), value: 'lineGrossWithDiscount', sortable: false}
    ];
    OrderService.getOrder(this.$route.params.id)
        .then(value => {
          this.order = value
          this.user = value.keycloakUser
          this.createItemList(this.order)
          this.createAdditionalInformations(value)
          this.sortStatusHistory(this.order)
        })
        .catch(reason => {
          if (reason['errors'] !== undefined) {
            this.$router.push({
              name: 'search',
              query: {message: 'default_error_message'}
            })
          } else {
            console.log(reason)
          }
        });
  },
  methods: {
    sendOrderConfirmation(number, locale) {
      this.loading = true
      OrderService.sendOrderConfirmation(number, locale)
          .then(value => {
            this.loading = false
            this.displayMessage(value.message, 'info')
          })
          .catch(reason => {
            this.loading = false
            console.error(reason)
            if (reason['errors'] !== undefined) {
              this.displayMessage(reason.errors)
            }
          })
    },
    sendInvoicePdf(number, invoicePdf, locale) {
      this.loading = true
      OrderService.sendInvoice(number, invoicePdf, locale)
          .then(value => {
            this.loading = false
            this.displayMessage(value.message, 'info')
          })
          .catch(reason => {
            this.loading = false
            console.error(reason)
            if (reason['errors'] !== undefined) {
              this.displayMessage(reason.errors)
            }
          })
    },
    sendShipmentConfirmation(number, shipmentId, locale) {
      this.loading = true
      OrderService.sendShipmentConfirmation(number, shipmentId, locale)
          .then(value => {
            this.loading = false
            this.displayMessage(value.message, 'info')
          })
          .catch(reason => {
            this.loading = false
            console.error(reason)
            if (reason['errors'] !== undefined) {
              this.displayMessage(reason.errors)
            }
          })
    },
    mapTranslations(translations, fallbackText) {
      console.log(this.$i18n.locale)
      let text = fallbackText
      if (translations) {
        console.log(translations)
        for ( const key in translations) {
          if (key.startsWith(this.$i18n.locale)) {
            text = translations[key];
          }
        }
      }
      return text
    },
    displayMessage(messageString, type = "warning") {
      this.message = messageString
      this.messageType = type
      this.snackbar = true
    },
    createItemList(order) {
      const itemList = order.items;
      const items = []
      if (itemList) {
        itemList.forEach(function (item) {
          items.push({
              description: item.description,
              itemNo: item.itemNo,
              unitGrossWithoutDiscount: formatMoney(item.unitGrossWithoutDiscount, order.currency),
              quantity: item.quantity,
              lineGrossWithoutDiscount: formatMoney(item.lineDiscountOnGross +item.lineGrossWithDiscount, order.currency),
              lineDiscountOnGross: formatMoney(- item.lineDiscountOnGross, order.currency),
              lineGrossWithDiscount: formatMoney(item.lineGrossWithDiscount, order.currency)
          });
        })
      }
      this.items = items
    },
    createAdditionalInformations(order) {
      this.additionalInformations['orderDate'] = this.formatDate(order.orderDate);
      this.additionalInformations['channel'] = order.shopOrderSystem;
      this.additionalInformations['customer'] = order.userCommunicationEmail;
    },
    sortStatusHistory(order) {
        order.statusHistory.sort(function(a, b) {
            var keyA = new Date(a.createdAt),
                keyB = new Date(b.createdAt);
            if (keyA > keyB) return -1;
            if (keyA < keyB) return 1;
            return 0;
        });
    },
    showCustomer(email) {
      this.$router.push({
        name: 'user_list',
        params: {email: email},
      })
    },
    formatMoney(total) {
      return formatMoney(total, this.order.currency);
    },
    formatDate(dateString) {
      return formatDate(dateString);
    },
  },
  computed: {
    showActions() {
      return this.order.type === 'sylius'
          && this.orderStatesForAction.includes(this.order.orderState)
          && (this.order.invoicePdf || (!this.order.postmarkHistory || !this.order.postmarkHistory.bounceError))
    },
  }
}
</script>

<style scoped>

</style>
